module.exports = __webpack_public_path__ + "static/media/MainNavTab.1688a165.PNG";